import dayjs from "dayjs";
import type { TrialExpiryHistory } from "./types";

export const TRIAL_COOLDOWN_DAYS = 15;

/** 使用已返回的历史到期时间，按用例“满15天”判断；缺失过期历史时不猜资格。 */
export function hasTrialCooldownElapsed(history: TrialExpiryHistory): boolean {
  const expired = history.lastExpireMemberList ?? [];
  if (!expired.length) return history.expireMember !== true;
  const times = expired.map(item => dayjs(item.endTime).valueOf());
  if (times.some(time => !Number.isFinite(time))) return false;
  const lastExpiry = Math.max(...times);
  return dayjs(history.now).valueOf() >= dayjs(lastExpiry).add(TRIAL_COOLDOWN_DAYS, "day").valueOf();
}
